import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=452a107f&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheFooter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=452a107f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a107f",
  null
  
)

export default component.exports